"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AntiAutoComplete = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const StyledInput = app_1.styled.input `
  position: fixed;
  pointer-events: none;
  width: 0;
  height: 0;
  opacity: 0;
`;
function AntiAutoComplete({ form, }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledInput, { type: "text", form: form }), (0, jsx_runtime_1.jsx)(StyledInput, { type: "password", form: form })] }));
}
exports.AntiAutoComplete = AntiAutoComplete;
